import { styled } from '@mui/material/styles';
import { Button, Dialog, List, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';

// Wrapper exposes class names used by Form (passed as strings)
export const RootWrap = styled('div')(({ theme }) => ({
  '& .task-tag-form-style': {
    position: 'relative',
    maxWidth: '1000px !important',
    overflow: 'visible !important',
    height: 'auto',
  },
  '& .task-tag-title-style': {
    fontSize: '18px !important',
    fontWeight: 'bold',
  },
  '& .task-tag-screen-width': {
    width: '100%',
    '& .MuiInput-formControl.Mui-disabled, .MuiInputLabel-formControl': {
      color: theme.palette.text.primary,
    },
    '& .Mui-disabled.MuiInputBase-formControl .MuiSelect-icon': {
      display: 'none',
    },
    '& .Mui-disabled.MuiInput-underline:before': {
      border: `none !important`,
    },
  },
  '& .task-tag-screen-container': {
    maxWidth: 'none !important',
  },
  '& .task-tag-screen-container-mobile': {
    maxWidth: 'none !important',
  },
}));

export const TT_FORM_STYLE = 'task-tag-form-style';
export const TT_TITLE_STYLE = 'task-tag-title-style';
export const TT_SCREEN_WIDTH = 'task-tag-screen-width';
export const TT_SCREEN_CONTAINER = 'task-tag-screen-container';
export const TT_SCREEN_CONTAINER_MOBILE = 'task-tag-screen-container-mobile';

export const StyledDialog = styled(Dialog)({
  // Must sit above the parent FullScreen modal (FullScreenDialog uses zIndex 1300)
  // so the "Link to Library" dialog is visible instead of rendering behind it.
  zIndex: 1400,
  '& .MuiPaper-root': { width: '90%', maxWidth: 600 },
});

export const Container = styled('div')(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(2),
  [theme.breakpoints.up('lg')]: {
    padding: theme.spacing(4),
  },
}));

export const Subtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  [theme.breakpoints.down('xl')]: {
    textAlign: 'center',
    paddingTop: theme.spacing(2),
  },
}));

export const InputContainer = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    margin: theme.spacing(1),
  },
}));

// Vertical margin only: the Scorecard select above sits flush with the dialog
// content's edges, so any horizontal margin here knocks the Search field out of
// alignment with it.
export const SearchContainer = styled('div')(({ theme }) => ({
  margin: theme.spacing(1, 0),
}));

export const ListWrap = styled('div')(({ theme }) => ({
  '& > li': {
    backgroundColor: theme.palette.action.disabled,
    marginBottom: 3,
  },
}));

// listStyles equivalents -----------------------------------------------------

export const ListRow = styled(ListItemButton)(({ theme }) => ({
  borderTop: `${theme.palette.action.disabled} solid 1px`,
  position: 'relative',
}));

export const MarginLeftList = styled(List)(({ theme }) => ({
  marginLeft: theme.spacing(2),
}));

export const MarginRightIcon = styled(ListItemIcon)(({ theme }) => ({
  marginRight: theme.spacing(4),
}));

export const TagContainerBtn = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})(({ theme, isActive }) => ({
  position: 'absolute',
  right: 0,
  top: 0,
  bottom: 0,
  backgroundColor: theme.palette.action.disabledBackground,
  color: isActive ? theme.palette.secondary.main : theme.palette.text.primary,
}));

export const CheckpointText = styled(ListItemText)({
  '& .MuiTypography-root': {
    fontSize: `14px !important`,
  },
});
